interface RecoveryBannerProps {
  onDismiss: () => void;
  storedAt?: number;
}

function describeAge(ms: number): string {
  const hours = Math.floor(ms / (60 * 60 * 1000));
  if (hours < 1) return 'zojuist';
  if (hours < 6) return `${hours} uur geleden`;
  if (hours < 24) return 'vanochtend';
  return 'gisteren';
}

export function RecoveryBanner({ onDismiss, storedAt }: RecoveryBannerProps) {
  const ageMs = storedAt ? Date.now() - storedAt : 0;
  // Show "stale" copy only if the session sat idle for more than half a day
  // so users know the context may feel disconnected before they pick up.
  const isStale = ageMs > 12 * 60 * 60 * 1000;
  const message = isStale
    ? `Sessie hersteld van ${describeAge(ageMs)}. Lees eventueel even terug voor je verdergaat.`
    : 'Sessie hersteld. Ga verder waar je was gebleven!';

  return (
    <div className="flex-shrink-0 px-4 py-2 bg-teal/30 border-b border-teal/40">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-off-black">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span>{message}</span>
        </div>
        <button
          onClick={onDismiss}
          className="text-off-black/60 hover:text-off-black transition-colors"
          aria-label="Sluiten"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
